import React, { useState } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

export default function Contact() {
  const [form, setForm] = useState({ name: '', company: '', phone: '', email: '', service: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          access_key: '79e4c43b-2004-45ec-b34f-c0e536a88bb4',
          name: form.name,
          company: form.company,
          phone: form.phone,
          email: form.email,
          service: form.service,
          message: form.message,
          subject: `New Quote Request from ${form.name}`,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setSubmitted(true);
      } else {
        alert('Something went wrong. Please try again or call us directly.');
      }
    } catch (error) {
      alert('Something went wrong. Please try again or call us directly.');
      console.error(error);
    }
  };

  const inputStyle = {
    width: '100%', padding: '12px 14px', borderRadius: '10px',
    border: '1.5px solid #e0dfd6', fontFamily: "'Inter'", fontSize: '15px',
    color: '#0d0d0d', background: '#fff', outline: 'none',
    transition: 'border-color 0.2s',
  };

  const labelStyle = { fontFamily: "'Inter'", fontSize: '13px', fontWeight: 500, color: '#5c5c56', display: 'block', marginBottom: '6px' };

  return (
      <section id="contact" className="bg-white lg-custom:py-20 py-12">
        <div className="dh-container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.2fr', gap: '80px', alignItems: 'start' }} className="contact-grid">

            <div>
              <div className="uppercase" style={{
                display: 'inline-block', background: '#e8effc', color: '#0a4abe',
                borderRadius: '100px', padding: '3px 14px', fontSize: '12px',
                fontFamily: "'Inter'", fontWeight: 500, marginBottom: '13px', letterSpacing: '0.5px',
              }}>
                get in touch
              </div>
              <h2 style={{
                fontFamily: "'Bebas Neue'",
                fontWeight: 900,
                fontSize: 'clamp(3rem, 6vw, 5.5rem)',
                lineHeight: '0.9',
                marginBottom: '1.5rem',
              }}>
                ready to<br/>scale your<br/>delivery?
              </h2>
              <p style={{ color: '#5c5c56', fontSize: '16px', fontFamily: "'Inter'", lineHeight: 1.7, marginBottom: '40px' }}>
                Join the growing network of Lebanese businesses that trust Delivery Hub as their logistics partner.
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {[
                  { icon: Phone, label: 'Call Us', value: '+961 76 799 990' },
                  { icon: Mail, label: 'Email', value: 'info@deliveryhub.me' },
                  { icon: MapPin, label: 'Headquarters', value: 'Ali Said El Khansa Street, Jnah, Lebanon' },
                ].map(c => (
                    <div key={c.label} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                      <div style={{
                        width: '44px', height: '44px', background: '#e8effc', borderRadius: '12px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}>
                        <c.icon size={20} color="#0a4abe" strokeWidth={1.75} />
                      </div>
                      <div>
                        <p style={{ fontFamily: "'Inter'", fontSize: '12px', color: '#9e9d95', marginBottom: '2px' }}>{c.label}</p>
                        <p style={{ fontFamily: "'Inter'", fontSize: '15px', color: '#0d0d0d', fontWeight: 500 }}>{c.value}</p>
                      </div>
                    </div>
                ))}
              </div>
            </div>

            {/* Right: form */}
            <div style={{
              background: '#f8f8f6', borderRadius: '20px', border: '1px solid #e0dfd6', padding: '40px',
            }}>
              {submitted ? (
                  <div style={{ textAlign: 'center', padding: '40px 0' }}>
                    <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
                    <h3 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: '22px', marginBottom: '10px' }}>Message Received!</h3>
                    <p style={{ fontFamily: "'Inter'", color: '#5c5c56', fontSize: '15px' }}>We'll reach out within 2 business days.</p>
                  </div>
              ) : (
                  <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                      <div>
                        <label style={labelStyle}>Full Name *</label>
                        <input style={inputStyle} name="name" value={form.name} onChange={handle} required placeholder="John Doe"
                               onFocus={e => e.target.style.borderColor = '#0a4abe'} onBlur={e => e.target.style.borderColor = '#e0dfd6'} />
                      </div>
                      <div>
                        <label style={labelStyle}>Company</label>
                        <input style={inputStyle} name="company" value={form.company} onChange={handle} placeholder="Acme Co."
                               onFocus={e => e.target.style.borderColor = '#0a4abe'} onBlur={e => e.target.style.borderColor = '#e0dfd6'} />
                      </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                      <div>
                        <label style={labelStyle}>Phone *</label>
                        <input style={inputStyle} name="phone" value={form.phone} onChange={handle} required placeholder="+961 XX XXX XXX"
                               onFocus={e => e.target.style.borderColor = '#0a4abe'} onBlur={e => e.target.style.borderColor = '#e0dfd6'} />
                      </div>
                      <div>
                        <label style={labelStyle}>Email</label>
                        <input style={inputStyle} name="email" type="email" value={form.email} onChange={handle} placeholder="you@company.com"
                               onFocus={e => e.target.style.borderColor = '#0a4abe'} onBlur={e => e.target.style.borderColor = '#e0dfd6'} />
                      </div>
                    </div>
                    <div>
                      <label style={labelStyle}>Service Needed</label>
                      <select style={{ ...inputStyle, appearance: 'none' }} name="service" value={form.service} onChange={handle}
                              onFocus={e => e.target.style.borderColor = '#0a4abe'} onBlur={e => e.target.style.borderColor = '#e0dfd6'}>
                        <option value="">Select a service…</option>
                        <option value="delivery">Domestic Delivery</option>
                        <option value="warehousing">Warehousing & Storage</option>
                        <option value="logistics">Logistics & Distribution</option>
                        <option value="other">Other / Not Sure</option>
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Tell Us More</label>
                      <textarea style={{ ...inputStyle, minHeight: '110px', resize: 'vertical' }}
                                name="message" value={form.message} onChange={handle}
                                placeholder="Describe your delivery needs, volume, frequency…"
                                onFocus={e => e.target.style.borderColor = '#0a4abe'} onBlur={e => e.target.style.borderColor = '#e0dfd6'} />
                    </div>
                    <button type="submit" style={{
                      background: '#0a4abe', color: '#fff', padding: '14px',
                      borderRadius: '10px', fontFamily: "'Inter'", fontWeight: 500, fontSize: '16px',
                      transition: 'background 0.2s, transform 0.15s', border: 'none', cursor: 'pointer',
                    }}
                            onMouseEnter={e => { e.target.style.background = '#083a96'; e.target.style.transform = 'translateY(-1px)'; }}
                            onMouseLeave={e => { e.target.style.background = '#0a4abe'; e.target.style.transform = 'none'; }}
                    >
                      Send Request →
                    </button>
                  </form>
              )}
            </div>
          </div>
        </div>

        <style>{`
        @media (max-width: 900px) {
          .contact-grid { grid-template-columns: 1fr !important; gap: 48px !important; }
        }
      `}</style>
      </section>
  );
}